// extracted by mini-css-extract-plugin
export default {"Code":"PhoneInput_Code_bZUR1"};